import { useEffect } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import ExternalAuthentication from '@utils/external-authentication'
import { useReactiveVar } from '@apollo/client/react'
import { isLoggingOut } from '@cache'

function Login() {
  const isLoggingOutVar = useReactiveVar(isLoggingOut)

  useEffect(() => {
    if (!isLoggingOutVar) {
      ExternalAuthentication.redirect()
    }
  }, [isLoggingOutVar])

  return (
    <Spinner animation='border' size='sm' variant='dark' />
  )
}

export default Login
